module.exports = __webpack_public_path__ + "img/Fuller.7825f8da.jpeg";